import Immutable from 'immutable';
import {
  FLAG_GETTING_ITEM_CATEGORIES,
  GET_ITEM_CATEGORIES,
  CLEAR_ITEM_CATEGORIES,
} from '../../../actions/types/baggage/ItemCategory';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  regular: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  special: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_ITEM_CATEGORIES:
      if (!action.payload.key) {
        return state.setIn(['all', 'loading'], action.payload.flag);
      }
      return state.setIn([action.payload.key, 'loading'], action.payload.flag);
    case GET_ITEM_CATEGORIES:
      if (!action.payload.key) {
        return state.setIn(
          ['all', 'content'],
          Immutable.Map(action.payload.data),
        );
      }
      return state.setIn(
        [action.payload.key, 'content'],
        Immutable.Map(action.payload.data),
      );
    case CLEAR_ITEM_CATEGORIES:
      if (!action.payload.key) {
        return state.setIn(['all', 'content'], Immutable.Map(COLLECTION_SHAPE));
      }
      return state.setIn(
        [action.payload.key, 'content'],
        Immutable.Map(COLLECTION_SHAPE),
      );
    default:
      return state;
  }
};
